<template>
  <section class="comp-lawyer-list">
    <div class="home-wrap-content-sec-lawyer" :class="isHomeTitle ? 'is-home-list' : ''">
      <div class="home-wrap-content-sec-lawyer-title">
        <p>圣诉律师联盟</p>
        <div class="location" v-if="isLocation">
          <img src="../../components/home/assets/icon-location-24.png" alt="">
          <span>{{city}}</span>
        </div>
      </div>
      <div class="home-wrap-content-sec-lawyer-wrap">
        <div class="home-wrap-content-sec-lawyer-wrap-item" v-for="(item, index) in lawyerList" :key="index">
          <img :src="item.avatar" alt="">
          <div class="home-wrap-content-sec-lawyer-wrap-item-content">
            <p class="home-wrap-content-sec-lawyer-wrap-item-content-top">
              在圣诉平台帮助了{{item.helper}}名用户
            </p>
            <div class="home-wrap-content-sec-lawyer-wrap-item-content-bottom">
              <p class="home-wrap-content-sec-lawyer-wrap-item-content-bottom-name">{{item.lawyerName}}</p>
              <p class="home-wrap-content-sec-lawyer-wrap-item-content-bottom-lawfirm">
                {{item.lawfirm}}
              </p>
              <p class="home-wrap-content-sec-lawyer-wrap-item-content-bottom-position">
                {{lawyerPositionFilter(item.lawyerPosition)}}
              </p>
            </div>
          </div>
          <div class="home-wrap-content-sec-lawyer-wrap-item-text">
            <div class="home-wrap-content-sec-lawyer-wrap-item-text-top">
              <div class="home-wrap-content-sec-lawyer-wrap-item-text-top-left">
                <div class="lawyer-title">专长领域</div>
                <div class="home-wrap-content-sec-lawyer-wrap-item-text-top-left-domain" v-for="(list, ind) in expertFieldFilter(item.expertField)" :key="ind">
                  <p>{{list}}</p>
                </div>
              </div>
              <div class="home-wrap-content-sec-lawyer-wrap-item-text-top-right">
                <div class="lawyer-title">从业时间</div>
                <div class="home-wrap-content-sec-lawyer-wrap-item-text-top-right-circle">
                  <el-progress :width="100" :stroke-width="4" type="circle"
                               :percentage="item.workYears > 50 ? 100 : !item.workYears ? 0 : (item.workYears)/50*100"
                               color="#ed6c00" :show-text="false"></el-progress>
                  <p class="home-wrap-content-sec-lawyer-wrap-item-text-top-right-circle-txt">
                    {{item.workYears ? item.workYears > 50 ? '50年' : item.workYears + '年' : '未知'}}
                  </p>
                </div>
              </div>
            </div>
            <div class="home-wrap-content-sec-lawyer-wrap-item-text-center">{{item.description}}</div>
            <router-link tag="div" :to="{name: 'lawyer-detail', query:{lawyerId: item.lawyerId}}" class="home-wrap-content-sec-lawyer-wrap-item-text-bottom">
              <div class="under-more">
                了解更多<Icon type="arrow-next" class="icon"></Icon>
              </div>
            </router-link>
          </div>
        </div>
        <div class="home-wrap-content-sec-lawyer-wrap-no" v-if="!lawyerList || !lawyerList.length">
          暂无律师信息
        </div>
      </div>
      <slot></slot>
    </div>
  </section>
</template>

<script>
  import Icon from '@/common-components/icon'
  export default {
    name: 'lawyer-list',
    components: {
      Icon
    },
    props: {
      lawyerList: {
        type: Array,
        default: []
      },
      isLocation: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        city: '',
        isHomeTitle: false
      }
    },
    mounted () {
      if (this.$route.path === '/service' || this.$route.path === '/lawyer') {
        this.isHomeTitle = true
      }
      this.getLocation('https://pv.sohu.com/cityjson?ie=utf-8')
    },
    methods: {
      // 获取地理位置
      getLocation (src) {
        let that = this
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = src
        document.getElementsByTagName('head')[0].appendChild(script)
        script.onload = function () {
          that.city = returnCitySN.cname // eslint-disable-line
          that.$emit('getCity', that.city)
        }
      },
      // 专业领域转化
      expertFieldFilter (data) {
        let arr = []
        let fileArr = { 1: '综合', 2: '诉讼业务(诉讼与仲裁)', 3: '非诉业务', 4: '政府法律顾问', 5: '企业法律顾问', 6: '刑事辩护', 7: '行政业务', 8: '民商事', 9: '婚姻家庭', 10: '交通事故', 11: '合同纠纷', 12: '劳动', 13: '国际业务', 14: '知识产权', 15: '公司业务', 16: '金融、证券、保险', 17: '资本市场、IPO、新三板', 18: '海商海事', 19: '环境、资源与能源', 20: '破产与重组', 21: '建设工程', 22: '房地产', 23: '财税', 24: '债权债务', 25: '房产纠纷', 26: '其他' }
        if (data === '' || data === null || data === undefined) return
        JSON.parse(data).forEach(item => {
          arr.push(fileArr[item])
        })
        return arr
      },
      // 职位转化
      lawyerPositionFilter (data) {
        let obj = {1: '主任', 2: '副主任', 3: '执行主任', 4: '高级合伙人', 5: '合伙人', 6: '律师', 7: '其他'}
        return obj[data]
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .is-home-list {
    padding-bottom .04rem !important
    .home-wrap-content-sec-lawyer-title {
      height: .32rem !important
      p {
        font-size .24rem !important
        height: .32rem !important
      }
    }
    .home-wrap-content-sec-lawyer {
      &-wrap {
        margin-top .40rem !important
      }
    }
  }
  .comp-lawyer-list {
    .home-wrap-content-sec-lawyer {
      width: 9.6rem
      margin 0 auto
      padding .72rem 0 .64rem 0
      &-title {
        display: flex
        justify-content space-between
        height: .5rem
        align-items center
        p {
          height: .5rem
          border-left .04rem solid #ed6c00
          font-size: .36rem;
          padding-left .16rem
        }
        .location {
          margin-right .15rem
          span {
            font-size: .18rem
            color: #ed6c00;
            position relative
            bottom .05rem
            mwrgin-left .1rem
            font-weight: 500
          }
        }
      }
      &-wrap {
        margin .54rem 0 .28rem 0
        display: flex
        justify-content space-around
        flex-wrap wrap
        &-item {
          width: 3rem
          position relative
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.04)
          background #fff
          margin-bottom .2rem
          padding-bottom .45rem
          img {
            width: 100%
            height: 4rem
          }
          &-content {
            position absolute
            top 0
            left 0
            width: 100%
            height: 4rem
            color #fff
            display flex
            flex-direction column
            justify-content space-between
            align-items center
            &-top {
              color: #fdba78;
              font-size: .16rem
              margin-top .24rem
              display none
            }
            &-bottom {
              position: absolute
              bottom .16rem
              text-align center
              &-name {
                font-size: .24rem;
                font-weight: 500;
                maargin .14rem 0 .08rem 0
              }
              &-lawfirm, &-position {
                font-size: .14rem
                overflow hidden
                text-overflow:ellipsis;
                white-space: nowrap;
              }
            }
          }
          &-text {
            padding .21rem .25rem .20rem .24rem
            &-top {
              display flex
              justify-content space-between
              .lawyer-title {
                font-size: .14rem;
                font-weight: 500;
                line-height: 1.14;
                color: #1d1b1b
                margin-bottom .15rem
              }
              &-left {
                &-domain {
                  p {
                    padding .07rem .16rem
                    border-radius: .3rem;
                    background-color: #ffe9d2;
                    font-size: .14rem
                    color: #ed6c00
                    margin-bottom .08rem
                  }
                }
              }
              &-right-circle {
                position relative
                width 1rem;
                height 1rem;
                &-txt {
                  position absolute
                  left 0
                  top 0
                  width: 100%
                  height: 100%
                  line-height 1rem
                  text-align center
                  font-weight: 500
                  color: #ed6c00
                  font-size: .24rem
                }
              }
            }
            &-center {
              width: 100%
              font-size: .14rem
              color: #3e3a3a
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              margin-top .1rem
            }
            &-bottom {
              margin-top .24rem
              font-size: .16rem
              font-weight: 500
              cursor pointer
              position absolute
              left .2rem
              bottom .24rem
              .icon {
                margin-left .08rem
                position relative
                top .03rem
              }
            }
            .active {
              color: #ed6c00
            }
          }
        }
        &-no {
          font-size: .24rem
          color #a9a9a9
        }
        &-item:hover {
          .home-wrap-content-sec-lawyer-wrap-item-content-top {
            display block
          }
          .under-more {
            color #ed6c00
          }
        }
      }
      &-btn {
        width: 4.32rem
        height: .64rem
        background-color: #ed6c00;
        font-size: .24rem
        text-align: center
        line-height .64rem
        color: #ffffff
        margin 0 auto
        cursor pointer
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/common-components/lawyer-list/lawyer-list.vue